<div class="w-100 overflow-x-auto d-block canvas-container">
    <div [ngStyle]="{ width: divWidth }">
        <canvas baseChart class="chart" [data]="barChartData" [options]="barChartOptions" [plugins]="barChartPlugins" [type]="barChartType"> </canvas>
    </div>
</div>
